import React from "react";
import Link from "./link";
import { Remarkable } from "remarkable";

const markdown = new Remarkable();

const JoinUsV2 = ({ content }) => {
  const { header, textParagraph, image, linkUrl } = content;

  return (
    <div id="joinUsV2">
      <div className="wrap">
        <img src={image.url} alt="joinUsImage" />
        <div className="contentContainer">
          <div className="header">{header}</div>
          <div className="textParagraph" dangerouslySetInnerHTML={{ __html: markdown.render(textParagraph) }} />
          <div className="joinUs">
            <Link
              link={linkUrl}
              text={
                <>
                  <span>Join Us</span>
                </>
              }
              className="buttonLink sm"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default JoinUsV2;
